// City Cards card game data with rankings
export const CITY_CARDS = [
  { id: 1, name: "New York City", rank: 1, image: "/images/city/city_1.jpg" },
  { id: 2, name: "Los Angeles", rank: 2, image: "/images/city/city_2.jpg" },
  { id: 3, name: "Chicago", rank: 3, image: "/images/city/city_3.jpg" },
  { id: 4, name: "Dallas", rank: 4, image: "/images/city/city_4.jpg" },
  { id: 5, name: "Houston", rank: 5, image: "/images/city/city_5.jpg" },
  { id: 6, name: "Miami", rank: 6, image: "/images/city/city_6.jpg" },
  { id: 7, name: "Washington D.C.", rank: 7, image: "/images/city/city_7.jpg" },
  { id: 8, name: "Atlanta", rank: 8, image: "/images/city/city_8.jpg" },
  { id: 9, name: "Philadelphia", rank: 9, image: "/images/city/city_9.jpg" },
  { id: 10, name: "Phoenix", rank: 10, image: "/images/city/city_10.jpg" },
  { id: 11, name: "Boston", rank: 11, image: "/images/city/city_11.jpg" },
  { id: 12, name: "Long Beach", rank: 12, image: "/images/city/city_12.jpg" },
  { id: 13, name: "San Francisco", rank: 13, image: "/images/city/city_13.jpg" },
  { id: 14, name: "Detroit", rank: 14, image: "/images/city/city_14.jpg" },
  { id: 15, name: "Seattle", rank: 15, image: "/images/city/city_15.jpg" },
  { id: 16, name: "Minneapolis", rank: 16, image: "/images/city/city_16.jpg" },
  { id: 17, name: "Tampa Bay", rank: 17, image: "/images/city/city_17.jpg" },
  { id: 18, name: "San Diego", rank: 18, image: "/images/city/city_18.jpg" },
  { id: 19, name: "Denver", rank: 19, image: "/images/city/city_19.jpg" },
  { id: 20, name: "Orlando", rank: 20, image: "/images/city/city_20.jpg" },
  { id: 21, name: "Charlotte", rank: 21, image: "/images/city/city_21.jpg" },
  { id: 22, name: "Baltimore", rank: 22, image: "/images/city/city_22.jpg" },
  { id: 23, name: "St. Louis", rank: 23, image: "/images/city/city_23.jpg" },
  { id: 24, name: "San Antonio", rank: 24, image: "/images/city/city_24.jpg" },
  { id: 25, name: "Austin", rank: 25, image: "/images/city/city_25.jpg" },
  { id: 26, name: "Portland", rank: 26, image: "/images/city/city_26.jpg" },
  { id: 27, name: "Sacramento", rank: 27, image: "/images/city/city_27.jpg" },
  { id: 28, name: "Pittsburgh", rank: 28, image: "/images/city/city_28.jpg" },
  { id: 29, name: "Las Vegas", rank: 29, image: "/images/city/city_29.jpg" },
  { id: 30, name: "Cincinnati", rank: 30, image: "/images/city/city_30.jpg" }
];
